import { bool, object, string } from 'prop-types';
import React from 'react';
import {
    KUN_LESING,
    SPORSMAL_SYSTEM,
    SPORSMALSTYPE_AMOUNT_CAP,
    SPORSMALSTYPE_NUMBER_CAP,
    SPORSMALSTYPE_RADIO_CAP,
    SPORSMALSTYPE_CHECKBOX_CAP,
    SPORSMALSTYPE_LAND_CAP,
} from '../constants/general';
import text from '../constants/text';
import HelpModal from '../help-modal';
import {
    getPreselected,
    isRequiredQuestion,
    isRequiredWhenSelected,
    IsSubQuestionAndShouldNotRender,
} from './helper/component-helper';
import connect from './helper/connect';
import questionMapper from './mapper';

const Question = ({ question, context, questionState, hasError, validateIfNotSet, appNamespace }) => {
    const labelsInComponent = [
        SPORSMALSTYPE_RADIO_CAP,
        SPORSMALSTYPE_NUMBER_CAP,
        SPORSMALSTYPE_AMOUNT_CAP,
        SPORSMALSTYPE_CHECKBOX_CAP,
    ];
    const getQuestionTekst = (question) => {
        // Support brittle sporsmalstekst with markup
        if (
            question.sporsmalstekst != null &&
            (question.formaterHTML || (question.config && question.config.formaterHTML)) &&
            !labelsInComponent.includes(question.type)
        ) {
            /* eslint-disable react/no-danger */
            return (
                <h2
                    className="skjema-input-question"
                    dangerouslySetInnerHTML={{
                        __html: question.sporsmalstekst,
                    }}
                />
            );
        }

        if (question.utfyllingsregel.regel === KUN_LESING && !labelsInComponent.includes(question.type)) {
            return <h2 className="skjema-input-question">{question.sporsmalstekst}</h2>;
        }

        return (
            !labelsInComponent.includes(question.type) && (
                <h2 className="skjema-input-question">
                    {isRequiredQuestion(question.utfyllingsregel) ||
                    (isRequiredWhenSelected(question) && getPreselected(question)) ||
                    (!isRequiredQuestion(question.utfyllingsregel) && question.type === SPORSMALSTYPE_LAND_CAP)
                        ? question.sporsmalstekst
                        : `${question.sporsmalstekst} ${text.TEXT_OPTIONAL}`}
                </h2>
            )
        );
    };

    if (IsSubQuestionAndShouldNotRender(context, question)) {
        return null;
    }

    if (question.synlighet === SPORSMAL_SYSTEM) {
        return null;
    }

    if (question.isSubQuestion) {
        return (
            <div
                className={`skjema-input-wrap-small sub-question-${question.requiredParent}`}
                id={`kdk-skjema-${question.definisjon}`}
            >
                <HelpModal question={question} appNamespace={appNamespace} />
                <div className="skjema-input-field-wrap-small skjema-input-field-wrap">
                    {questionMapper(question, questionState, hasError, validateIfNotSet, appNamespace, true)}
                </div>
            </div>
        );
    }

    return (
        <div className="skjema-input-wrap" id={`kdk-skjema-${question.definisjon}`}>
            <HelpModal question={question} appNamespace={appNamespace} />
            {getQuestionTekst(question)}
            <div className="skjema-input-field-wrap">
                {questionMapper(question, questionState, hasError, validateIfNotSet, appNamespace, false)}
            </div>
        </div>
    );
};

Question.propTypes = {
    question: object.isRequired,
    context: object,
    questionState: object,
    hasError: bool,
    validateIfNotSet: object,
    appNamespace: string,
};

export default connect(Question);
